import React, {
  useEffect,
  useMemo,
  useState,
} from "react";

import {
  useTranslation,
} from "react-i18next";

import {
  FiSearch,
  FiRefreshCw,
  FiX,
  FiFilter,
  FiTag,
  FiDollarSign,
  FiChevronDown,
} from "react-icons/fi";


function Fillter({
  titleAr,
  setTitleAr,

  titleEn,
  setTitleEn,

  price,
  setPrice,

  categoryId,
  setCategoryId,

  AllCategory = [],
}) {
  const {
    t,
    i18n,
  } = useTranslation();


  /* =====================================
      LOCAL FILTER VALUES
  ====================================== */

  const [
    fTitleAr,
    setFTitleAr,
  ] = useState(
    titleAr || ""
  );


  const [
    fTitleEn,
    setFTitleEn,
  ] = useState(
    titleEn || ""
  );


  const [
    fPrice,
    setFPrice,
  ] = useState(
    price || ""
  );


  const [
    fCategoryId,
    setFCategoryId,
  ] = useState(
    categoryId || ""
  );


  /* =====================================
      LANGUAGE
  ====================================== */

  const isArabic =
    i18n.language === "ar" ||
    i18n.language?.startsWith(
      "ar"
    );


  /* =====================================
      SYNC LOCAL WITH PARENT
  ====================================== */

  useEffect(() => {
    setFTitleAr(
      titleAr || ""
    );
  }, [
    titleAr,
  ]);


  useEffect(() => {
    setFTitleEn(
      titleEn || ""
    );
  }, [
    titleEn,
  ]);


  useEffect(() => {
    setFPrice(
      price || ""
    );
  }, [
    price,
  ]);


  useEffect(() => {
    setFCategoryId(
      categoryId || ""
    );
  }, [
    categoryId,
  ]);


  /* =====================================
      SELECTED CATEGORY
  ====================================== */

  const selectedCategory =
    useMemo(
      () =>
        AllCategory?.find(
          (item) =>
            item?._id ===
            categoryId
        ),

      [
        AllCategory,
        categoryId,
      ]
    );


  /* =====================================
      SEARCH
  ====================================== */

  const handleSearch = () => {

    if (
      setTitleAr
    ) {
      setTitleAr(
        fTitleAr.trim()
      );
    }


    if (
      setTitleEn
    ) {
      setTitleEn(
        fTitleEn.trim()
      );
    }


    if (
      setPrice
    ) {
      setPrice(
        fPrice
      );
    }


    if (
      setCategoryId
    ) {
      setCategoryId(
        fCategoryId
      );
    }

  };


  /* =====================================
      RESET
  ====================================== */

  const handleReset = () => {

    setFTitleAr("");
    setFTitleEn("");
    setFPrice("");
    setFCategoryId("");


    if (
      setTitleAr
    ) {
      setTitleAr("");
    }


    if (
      setTitleEn
    ) {
      setTitleEn("");
    }


    if (
      setPrice
    ) {
      setPrice("");
    }


    if (
      setCategoryId
    ) {
      setCategoryId("");
    }

  };


  /* =====================================
      CLEAR INDIVIDUAL FILTERS
  ====================================== */

  const clearArabic = () => {

    setFTitleAr("");

    if (
      setTitleAr
    ) {
      setTitleAr("");
    }

  };


  const clearEnglish = () => {

    setFTitleEn("");

    if (
      setTitleEn
    ) {
      setTitleEn("");
    }

  };


  const clearPrice = () => {

    setFPrice("");

    if (
      setPrice
    ) {
      setPrice("");
    }

  };


  const clearCategory = () => {

    setFCategoryId("");

    if (
      setCategoryId
    ) {
      setCategoryId("");
    }

  };


  /* =====================================
      ENTER TO SEARCH
  ====================================== */

  const handleKeyDown =
    (e) => {

      if (
        e.key === "Enter"
      ) {
        e.preventDefault();

        handleSearch();
      }

    };


  /* =====================================
      ACTIVE FILTER
  ====================================== */

  const hasActiveFilter =
    Boolean(
      titleAr ||
      titleEn ||
      price ||
      categoryId
    );


  const hasLocalFilter =
    Boolean(
      fTitleAr ||
      fTitleEn ||
      fPrice ||
      fCategoryId
    );


  return (
    <div
      className="
        w-full
      "
    >

      {/* =================================
          FILTER GRID
      ================================= */}

      <div
        className="
          grid

          grid-cols-1
          md:grid-cols-2
          2xl:grid-cols-[1fr_1fr_0.85fr_0.7fr_auto]

          gap-3

          items-end
        "
      >

        {/* =================================
            ARABIC TITLE
        ================================= */}

        {titleAr !== null && (

          <FilterField
            label={t(
              "Title (Ar)"
            )}

            icon={
              <FiSearch
                size={15}
              />
            }
          >

            <input
              type="text"

              dir="rtl"

              value={
                fTitleAr
              }

              onChange={(
                e
              ) =>
                setFTitleAr(
                  e.target.value
                )
              }

              onKeyDown={
                handleKeyDown
              }

              placeholder={t(
                "Search Arabic offer"
              )}

              className="
                w-full
                h-full

                bg-transparent

                px-1

                font-kufi
                text-[11px]
                md:text-xs

                text-color-2
                dark:text-white

                placeholder:text-color-2/30
                dark:placeholder:text-white/25

                outline-none
              "
            />


            {fTitleAr && (

              <ClearButton
                onClick={() =>
                  setFTitleAr("")
                }
              />

            )}

          </FilterField>

        )}


        {/* =================================
            ENGLISH TITLE
        ================================= */}

        {titleEn !== null && (

          <FilterField
            label={t(
              "Title (En)"
            )}

            icon={
              <FiSearch
                size={15}
              />
            }
          >

            <input
              type="text"

              dir="ltr"

              value={
                fTitleEn
              }

              onChange={(
                e
              ) =>
                setFTitleEn(
                  e.target.value
                )
              }

              onKeyDown={
                handleKeyDown
              }

              placeholder={t(
                "Search English offer"
              )}

              className="
                w-full
                h-full

                bg-transparent

                px-1

                text-[11px]
                md:text-xs

                text-color-2
                dark:text-white

                placeholder:text-color-2/30
                dark:placeholder:text-white/25

                outline-none
              "
            />


            {fTitleEn && (

              <ClearButton
                onClick={() =>
                  setFTitleEn("")
                }
              />

            )}

          </FilterField>

        )}


        {/* =================================
            CATEGORY
        ================================= */}

        {Array.isArray(
          AllCategory
        ) &&
          AllCategory.length >
            0 && (

          <div
            className="
              w-full
            "
          >

            <label
              className="
                block

                mb-2

                font-kufi
                font-medium

                text-[10px]
                md:text-[11px]

                text-color-2/60
                dark:text-white/50
              "
            >
              {t(
                "Select Category"
              )}
            </label>


            <div
              className="
                relative

                flex

                h-[48px]

                items-center

                overflow-hidden

                rounded-[1rem]

                border
                border-color-2/10
                dark:border-white/10

                bg-back-secondary/60
                dark:bg-back-darkprimery/60

                transition-all
                duration-300

                focus-within:border-color-1/60

                focus-within:shadow-[0_0_0_3px_rgba(165,119,58,.08)]
              "
            >

              {/* Icon */}

              <div
                className="
                  flex

                  w-11
                  h-full

                  shrink-0

                  items-center
                  justify-center

                  text-color-1
                "
              >
                <FiTag
                  size={15}
                />
              </div>


              {/* Select */}

              <select
                value={
                  fCategoryId
                }

                onChange={(
                  e
                ) =>
                  setFCategoryId(
                    e.target.value
                  )
                }

                className="
                  relative
                  z-10

                  w-full
                  h-full

                  appearance-none

                  bg-transparent

                  pe-9

                  font-kufi
                  text-[11px]
                  md:text-xs

                  text-color-2
                  dark:text-white

                  outline-none

                  cursor-pointer
                "
              >

                <option
                  value=""
                >
                  {t(
                    "All Categories"
                  )}
                </option>


                {AllCategory.map(
                  (
                    category
                  ) => (

                    <option
                      key={
                        category._id
                      }

                      value={
                        category._id
                      }
                    >
                      {isArabic
                        ? category.titleAr
                        : category.titleEn}
                    </option>

                  )
                )}

              </select>


              <FiChevronDown
                size={14}

                className="
                  absolute

                  end-3

                  pointer-events-none

                  text-color-1
                "
              />

            </div>

          </div>

        )}


        {/* =================================
            PRICE
        ================================= */}

        {price !== null && (

          <FilterField
            label={t(
              "Price"
            )}

            icon={
              <FiDollarSign
                size={15}
              />
            }
          >

            <input
              type="number"

              min="0"

              value={
                fPrice
              }

              onChange={(
                e
              ) =>
                setFPrice(
                  e.target.value
                )
              }

              onKeyDown={
                handleKeyDown
              }

              placeholder={t(
                "Price"
              )}

              className="
                w-full
                h-full

                bg-transparent

                px-1

                text-[11px]
                md:text-xs

                text-color-2
                dark:text-white

                placeholder:text-color-2/30
                dark:placeholder:text-white/25

                outline-none

                [appearance:textfield]

                [&::-webkit-outer-spin-button]:appearance-none
                [&::-webkit-inner-spin-button]:appearance-none
              "
            />


            {fPrice && (

              <ClearButton
                onClick={() =>
                  setFPrice("")
                }
              />

            )}

          </FilterField>

        )}


        {/* =================================
            ACTIONS
        ================================= */}

        <div
          className="
            flex

            md:col-span-2
            2xl:col-span-1

            items-center

            gap-2
          "
        >

          {/* Search */}

          <button
            type="button"

            onClick={
              handleSearch
            }

            className="
              flex

              h-[48px]

              flex-1
              2xl:flex-none

              items-center
              justify-center

              gap-2

              rounded-[1rem]

              bg-color-1

              px-5

              font-kufi
              font-semibold

              text-[11px]

              text-white

              whitespace-nowrap

              transition-all
              duration-300

              hover:bg-color-2

              hover:shadow-[0_8px_22px_rgba(165,119,58,.22)]

              active:scale-[0.98]
            "
          >
            <FiSearch
              size={15}
            />

            {t(
              "Search"
            )}
          </button>


          {/* Reset */}

          <button
            type="button"

            onClick={
              handleReset
            }

            disabled={
              !hasLocalFilter &&
              !hasActiveFilter
            }

            title={
              t("Reset")
            }

            className="
              flex

              w-[48px]
              h-[48px]

              shrink-0

              items-center
              justify-center

              rounded-[1rem]

              border
              border-color-1/15

              bg-color-1/5

              text-color-1

              transition-all
              duration-300

              hover:border-color-1
              hover:bg-color-1
              hover:text-white

              disabled:cursor-not-allowed
              disabled:opacity-30
            "
          >
            <FiRefreshCw
              size={16}
            />
          </button>

        </div>

      </div>


      {/* =================================
          ACTIVE FILTERS
      ================================= */}

      {hasActiveFilter && (

        <div
          className="
            flex
            flex-wrap

            items-center

            gap-2

            mt-4

            pt-4

            border-t
            border-color-2/[0.07]
            dark:border-white/[0.07]
          "
        >

          {/* Label */}

          <div
            className="
              flex

              items-center

              gap-2

              me-1

              font-kufi
              text-[9px]

              text-color-2/45
              dark:text-white/35
            "
          >
            <FiFilter
              size={12}

              className="
                text-color-1
              "
            />

            {t(
              "Active Filters"
            )}
          </div>


          {/* Arabic */}

          {titleAr && (

            <FilterChip
              label={
                titleAr
              }

              onRemove={
                clearArabic
              }

              rtl
            />

          )}


          {/* English */}

          {titleEn && (

            <FilterChip
              label={
                titleEn
              }

              onRemove={
                clearEnglish
              }
            />

          )}


          {/* Category */}

          {categoryId && (

            <FilterChip
              icon={
                <FiTag
                  size={11}
                />
              }

              label={
                selectedCategory
                  ? isArabic
                    ? selectedCategory
                        .titleAr
                    : selectedCategory
                        .titleEn
                  : t(
                      "Category"
                    )
              }

              onRemove={
                clearCategory
              }
            />

          )}


          {/* Price */}

          {price && (

            <FilterChip
              icon={
                <FiDollarSign
                  size={11}
                />
              }

              label={`${price} ${t(
                "currency"
              )}`}

              onRemove={
                clearPrice
              }
            />

          )}


          {/* Reset All */}

          <button
            type="button"

            onClick={
              handleReset
            }

            className="
              flex

              items-center

              gap-1.5

              rounded-full

              border
              border-color-2/10
              dark:border-white/10

              px-3
              py-1.5

              font-kufi
              text-[9px]

              text-color-2/45
              dark:text-white/40

              transition-all

              hover:border-red-500/20
              hover:bg-red-500/[0.05]
              hover:text-red-500
            "
          >
            <FiRefreshCw
              size={10}
            />

            {t(
              "Clear All"
            )}
          </button>

        </div>

      )}

    </div>
  );
}


/* =====================================
    FILTER FIELD
====================================== */

function FilterField({
  label,
  icon,
  children,
}) {
  return (
    <div
      className="
        w-full
      "
    >

      <label
        className="
          block

          mb-2

          font-kufi
          font-medium

          text-[10px]
          md:text-[11px]

          text-color-2/60
          dark:text-white/50
        "
      >
        {label}
      </label>


      <div
        className="
          group

          flex

          h-[48px]

          items-center

          overflow-hidden

          rounded-[1rem]

          border
          border-color-2/10
          dark:border-white/10

          bg-back-secondary/60
          dark:bg-back-darkprimery/60

          transition-all
          duration-300

          focus-within:border-color-1/60

          focus-within:bg-back-primery
          dark:focus-within:bg-back-darksecondary

          focus-within:shadow-[0_0_0_3px_rgba(165,119,58,.08)]
        "
      >

        <div
          className="
            flex

            w-11
            h-full

            shrink-0

            items-center
            justify-center

            text-color-1
          "
        >
          {icon}
        </div>


        {children}

      </div>

    </div>
  );
}


/* =====================================
    CLEAR BUTTON
====================================== */

function ClearButton({
  onClick,
}) {
  return (
    <button
      type="button"

      onClick={
        onClick
      }

      className="
        flex

        w-10
        h-full

        shrink-0

        items-center
        justify-center

        text-color-2/30
        dark:text-white/25

        transition-colors

        hover:text-color-1
      "
    >
      <FiX
        size={14}
      />
    </button>
  );
}


/* =====================================
    ACTIVE FILTER CHIP
====================================== */

function FilterChip({
  label,
  onRemove,
  icon,
  rtl = false,
}) {
  return (
    <button
      type="button"

      onClick={
        onRemove
      }

      className="
        group

        inline-flex

        max-w-[190px]

        items-center

        gap-2

        rounded-full

        border
        border-color-1/10

        bg-color-1/10

        px-3
        py-1.5

        font-kufi
        text-[9px]

        text-color-1

        transition-all

        hover:border-color-1
        hover:bg-color-1
        hover:text-white
      "
    >

      {icon}


      <span
        dir={
          rtl
            ? "rtl"
            : undefined
        }

        className="
          max-w-[130px]

          truncate
        "
      >
        {label}
      </span>


      <FiX
        size={10}
      />

    </button>
  );
}


export default Fillter;